export default __webpack_public_path__ + "static/media/slice-sidebar-annotations-large.5c5a97a4.png";